import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../../components/templates/Layout'
import CustomTableManage from '../TableSettings/CustomTableManage'

const PaymentLogs = (props) => {
    const [tableValues, setTableValues] = useState([
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'transactionID',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Transaction ID',
        },
        {
            field: 'request',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Request ID',
        },
        {
            field: 'cart_id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Cart ID',
        },
        {
            field: 'response',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Response',
        },
    ])

    const [fieldValue, setFieldValue] = useState([])

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <CustomTableManage
                primaryTable="payment_logs"
                tableHeading="Payment Logs"
                arrayValue={fieldValue}
                tableValues={tableValues}
                initialLimit={20}
                orderBy={'pl.id, desc'}
                tableJoins={[
                    {
                        baseTable: 'users',
                        customTable: 'custom_users',
                        joinType: 'inner',
                        baseJoinField: 'id',
                        connectJoinField: 'user_id',
                    },
                ]}
            ></CustomTableManage>
        </Layout>
    )
}

export default PaymentLogs
